import axios from '../util/axiosConfig';

export const fetchCountriesAPI = async () => {
    return await axios.get(`/api/v1/countries`).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data }
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const fetchCountryStatesAPI = async (countryId) => {
    return await axios.get(`/api/v1/${countryId}/states`, {
        params: {
            'country-id': countryId
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data }
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}